import { t } from "i18next";
import React, {useEffect} from "react";
import store from "../../../redux/store";
import {setTemporaryNotifications} from "../../../redux/notifications/actions";
import {defaultNotificationCreator} from "../../../templates/Notifications";
import NeedReaction from "./NeedReaction";
import {IHistoryCurrentNotification} from "../../../redux/notifications/reducer";

interface INotificationInfoProps {
    result: string,
    error: string,
    currentNotification: IHistoryCurrentNotification,
}

const NotificationInfo: React.FC<INotificationInfoProps> = ({
    result,
    error,
    currentNotification
}) => {

    function copyProductsToClipboard() {
        const data = {
            title: 'Продукты для копирования не найдены',
            description: "",
            iconType: 'warning'
        }

        const pids = document.getElementById('errorValidationProductIds')?.innerText || ''
        if (pids) {
            navigator.clipboard.writeText(pids);
            data.title = 'Идентификаторы продуктов скопированы в буфер'
            data.iconType = 'success'
        }

        store.dispatch(setTemporaryNotifications(
            defaultNotificationCreator(data)
        ))
    }

    useEffect(() => {
        const clickHandler = (e:{target: HTMLButtonElement}) => {
            if(!e.target.className.includes('copyTextButton')) return
            copyProductsToClipboard()
        };
        document.addEventListener('click', clickHandler as any);
        return () => document.removeEventListener('click', clickHandler as any);
    }, []);

    return (
        <>
            <div style={{maxWidth: "100%", whiteSpace: "break-spaces", wordBreak: "break-word"}}>
                <div className={`${error && result && 'mb-4'} max-h-[400px] overflow-auto`}>
                    {result && <div dangerouslySetInnerHTML={{ __html: result }} />}
                </div>

                {error &&
                    <>
                        <h5>{t<string>("errors")}:</h5>
                        <div className="text-xs max-h-[400px] overflow-auto">
                            <div dangerouslySetInnerHTML={{ __html: error }} />
                        </div>
                    </>
                }
            </div>
            {
                currentNotification.data && currentNotification.data.progressData.needReaction &&
                <NeedReaction notificationId={currentNotification.data.id} reactions={currentNotification.data.progressData.needReaction}></NeedReaction>
            }
        </>


    )

}

export default NotificationInfo;